import CustomDialog from "components/Atoms/CustomDialog"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import { useOrderItemBookingsLazyQuery } from "generated/graphql"
import React from "react"
import { useNavigate, useParams } from "react-router-dom"
dayjs.extend(advancedFormat)

interface OrderItemDetailProps {
  itemId: string
  sellableItem: any
  quantity: number
  isOpen: boolean
  onClose: any
}
const OrderItemDetail = ({
  itemId,
  sellableItem,
  isOpen,
  quantity,
  onClose,
}: OrderItemDetailProps) => {
  const { id } = useParams<{ id: string }>()
  const [getData, { data }] = useOrderItemBookingsLazyQuery()

  const bookings = data?.bookingsByOrderItem ?? []
  const navigate = useNavigate()
  return (
    <CustomDialog
      light
      onOpening={e => {
        getData({
          variables: {
            orderItemId: itemId,
          },
        })
      }}
      icon="shopping-cart"
      title={
        <span>
          {sellableItem?.name} -{" "}
          <span className="vt-muted">{quantity ?? 0} Units</span>
        </span>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      <section className="ds-order-item-bookings">
        {bookings?.map(booking => {
          const trip = booking?.trip
          const vehicle = trip?.vehicle
          const current = trip?.id === id

          return (
            <div className={current ? "current" : undefined} key={booking?.id}>
              <div>{dayjs(trip?.date).format("Do MMM YY")}</div>
              <div
                className="vt-styled-link-text"
                onClick={() => {
                  if (!current) {
                    navigate(`/d/ecom/dispatch/${trip?.id}`)
                  }
                  onClose()
                }}
              >
                {vehicle?.registrationNumber}
              </div>
              <div>{booking?.requiredQuantity ?? 0} Units</div>
            </div>
          )
        })}
      </section>
    </CustomDialog>
  )
}

export default OrderItemDetail
